import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './authApi';

export const discountApi = createApi({
  reducerPath: 'discountApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['PosDiscount', 'ApprovalRequest'],
  endpoints: (builder) => ({

    getPosDiscounts: builder.query({
      query: (params = {}) => ({ url: '/discounts', params }),
      providesTags: [{ type: 'PosDiscount', id: 'LIST' }],
    }),

    getPosApprovalRequest: builder.query({
      query: (id) => `/discount_approval_requests/${id}`,
      providesTags: (result, error, id) => [{ type: 'ApprovalRequest', id }],
    }),

    cancelApprovalRequest: builder.mutation({
      query: (id) => ({
        url: `/discount_approval_requests/${id}/cancel`,
        method: 'POST',
      }),
    }),

    startOtpCycle: builder.mutation({
      query: (requestId) => ({
        url: `/discount_approval_requests/${requestId}/otp_cycles`,
        method: 'POST',
      }),
    }),

    resendOtpCycle: builder.mutation({
      query: ({ requestId, cycleId }) => ({
        url: `/discount_approval_requests/${requestId}/otp_cycles/${cycleId}/resend`,
        method: 'POST',
      }),
    }),

    verifyOtpCycle: builder.mutation({
      query: ({ requestId, cycleId, code }) => ({
        url: `/discount_approval_requests/${requestId}/otp_cycles/${cycleId}/verify`,
        method: 'POST',
        body: { code },
      }),
    }),

  }),
});

export const {
  useGetPosDiscountsQuery,
  useLazyGetPosDiscountsQuery,
  useLazyGetPosApprovalRequestQuery,
  useCancelApprovalRequestMutation,
  useStartOtpCycleMutation,
  useResendOtpCycleMutation,
  useVerifyOtpCycleMutation,
} = discountApi;
